import { TypeFornecedor } from "../../../../Models/Pessoa/Fornecedor";
import { useFornecedorListar } from "../../../../Services/Pessoa/FornecedorService";
import { ISelectComPesquisaProps, SelectComPesquisa } from "../../../SelectComPesquisa";
export interface IFornecedorSelectProps extends ISelectComPesquisaProps {
    filtros?:TypeFornecedor;
}
export default function FornecedorSelect({
    filtros,
    placeholder,
    loading,
    allowClear,
    ...props
}:IFornecedorSelectProps) {
    filtros = filtros ?? {
        ativo : true
    };
    filtros.ativo = filtros.ativo === undefined ? true : filtros.ativo;

    const {
        data,
        isLoading
    } = useFornecedorListar({
        fornecedor : filtros
    });

    return <SelectComPesquisa 
        {...props}
        placeholder={placeholder ?? "Todos"}
        allowClear={allowClear ?? true}
        loading={isLoading || loading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : (m.nomeSocial?.length ?? 0 > 0) ? m.nomeSocial : m.nome
            }
        })}
    />
}